export default {"footer":"E7rGh","plusFooter":"hsU8q","plusFooterWrapper":"_8YElf"};